import { z } from 'zod';

/**
 * Validation schema for the Padel Schedule step.
 */
export const padelScheduleStepSchema = z.object({
  startDate: z.date().nullable(),
  endDate: z.date().nullable(),
  signupDeadlineDate: z
    .date({ required_error: 'La fecha de cierre es requerida' })
    .nullable()
    .refine((val) => val !== null, {
      message: 'Debes establecer una fecha de cierre de inscripción',
    }),
  matchDuration: z
    .number()
    .min(30, 'Mínimo 30 minutos para pádel')
    .max(120, 'Máximo 120 minutos para pádel'),
  schedule: z
    .array(
      z.object({
        club: z.object({ id: z.string() }),
        schedule: z.array(z.any()),
      })
    )
    .min(1, 'Debes configurar al menos un horario'),
});

export type PadelScheduleStepData = z.infer<typeof padelScheduleStepSchema>;
